import { PetsEnum, RecurrenceEnum } from "../../SalesLead/Lead.model";

const petsOptions = [
  {
    label: "Yes",
    value: PetsEnum.Y,
  },
  {
    label: "No",
    value: PetsEnum.N,
  },
  {
    label: "Not Applicable",
    value: PetsEnum.NA,
  },
];

const recurrenceOptions = [
  {
    label: "Yes",
    value: RecurrenceEnum.Y,
  },
  {
    label: "No",
    value: RecurrenceEnum.N,
  },
  {
    label: "Not Applicable",
    value: RecurrenceEnum.NA,
  },
];

export {
  petsOptions,
  recurrenceOptions
}